// @file Composable to scroll to newest post when it appears
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import type { Cid } from '@@/types'
import { storeToRefs } from 'pinia'
import { nextTick, watch } from 'vue'

export function useScrollToNewestPost(): void {
  const surfaceStore = useSurfaceStore()
  const surfacePostsStore = useSurfacePostsStore()

  const { format, newPostLocation } = storeToRefs(surfaceStore)
  const { newestPostCid } = storeToRefs(surfacePostsStore)

  watch(newestPostCid, (postCid: Cid) => {
    if (newPostLocation.value === 'bottom' || format.value === 'timeline') {
      nextTick(() => {
        const element = document.getElementById(`wish-${postCid}`) ?? document.getElementById('wish-new')
        element?.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' })
      })
    }
  })
}
